(function () {
  TimeslotService.$inject = ["API_URL", "$http", "$q", "$rootScope", "$filter"];
  angular.module('calendarApp').service('TimeslotService', TimeslotService);

  function TimeslotService(API_URL, $http, $q, $rootScope, $filter) {
    function servicesWithShifts(services, days) {
      var validServices = [],
          shifts = [];
      days.forEach(function (day) {
        shifts = shifts.concat(day.shifts);
      });

      for (var i = 0; i < services.length; i++) {
        for (var j = 0; j < shifts.length; j++) {
          if (services[i]._id === shifts[j].serviceid) {
            validServices.push(services[i]);
            break;
          }
        }
      }

      return validServices;
    }

    this.getTimeslots = function (filters) {
      var deferred = $q.defer();
      var timeslotOptions = angular.copy(filters || {}),
          availableDayOptions = angular.copy(filters || {});
      availableDayOptions.startdate = moment().format('YYYY-MM-DD');
      availableDayOptions.ignorebooked = true; // Why??

      var promises = [$http.get(API_URL + '/api/v1/calendar/timeslots/' + smooth.orgid, {
        params: timeslotOptions
      }), $http.get(API_URL + '/api/v1/daysavailable/' + smooth.orgid, {
        params: availableDayOptions
      }), $http.get(API_URL + '/api/v1/availableresources/' + smooth.orgid, {
        params: filters
      }), $http.get(API_URL + '/api/v1/services/' + smooth.orgid + '?getcost=true&enabledonly=true')];
      $q.all(promises).then(function (responses) {
        var success = true,
            message = '';
        responses.forEach(function (response) {
          if (!response.data.success) {
            success = false;
            message = response.data.msg;
          }
        });

        if (!success) {
          deferred.reject({
            msg: message
          });
          return;
        }

        var days = responses[0].data,
            daysAvailable = responses[1].data,
            resourceResponse = responses[2].data,
            serviceResponse = responses[3].data; // var services = servicesWithShifts(serviceResponse.services, days.timeslots);

        deferred.resolve({
          success: true,
          days: days.timeslots,
          daysAvailable: daysAvailable.days,
          resources: resourceResponse.resources,
          services: serviceResponse.services
        });
      }, function (error) {
        deferred.reject({
          success: false,
          msg: error.message
        });
      });
      return deferred.promise;
    };
  }
})();